/** Workspace-secret limits and statuses owned by the workspace secrets module. */
export const WORKSPACE_SECRET_KEY_MAX_LENGTH = 255
export const WORKSPACE_SECRET_VALUE_MAX_LENGTH = 10_000
export const WORKSPACE_SECRET_DESCRIPTION_MAX_LENGTH = 1_000

export const WORKSPACE_SECRET_KEY_PATTERN = /^[A-Z][A-Z0-9_]*$/

export type WorkspaceSecretMutationStatus = 'created' | 'updated' | 'deleted'

export const WORKSPACE_SECRET_ERROR_CODES = [
  'UNAUTHORIZED',
  'FORBIDDEN',
  'WORKSPACE_NOT_FOUND',
  'SECRET_NOT_FOUND',
  'INVALID_SECRET_KEY',
  'INVALID_SECRET_VALUE',
  'INVALID_SECRET_DESCRIPTION',
] as const

export type WorkspaceSecretErrorCode =
  (typeof WORKSPACE_SECRET_ERROR_CODES)[number]
